import { createFileRoute } from '@tanstack/react-router';

import { TemplateLoading } from '@/_pages/agreements/template/template-loading';

export const Route = createFileRoute('/_private/agreements/_template')({
  pendingComponent: TemplateLoading,
});
